import {Button} from '@progress/kendo-react-buttons'
import React from 'react'
import {connect} from 'react-redux'
import {Col, Container, Form, Row} from 'reactstrap'
import {FlashMessage} from '../../components/flash-message'
import * as RasaForm from '../../components/form'
import * as Link from '../../components/link'
import {Loading} from '../../components/loading'
import { RasaMenu } from '../../components/menu'
import * as RasaInput from '../../components/rasa-input'
import * as Actions from './actions'
import './styles.css'
import * as Types from './types'

interface DispatchProps {
  onSubmit: RasaForm.FormActionCreator<Types.FormFields>,
  updateField: RasaForm.FormActionCreator<Types.FormFields>,
}

interface FirstLoginProps {
  firstLogin: boolean,
}

type Props = Types.WrappedState & DispatchProps & FirstLoginProps
export const ResetPasswordPageConnect = ({firstLogin, resetPassword, onSubmit, updateField}: Props) =>
  <div>
    <Container fluid className="reset">
      <RasaMenu />
      <FlashMessage />
      <div className="reset-password">
        <Row>
          <Col className="text-center"><h1>Reset Password</h1></Col>
        </Row>
        <Row>
          <Col sm="12" md={{offset: 4, size: 4}}>
            <Form className="k-form reset-password-form" onSubmit={Link.preventDefaultThen(() =>
                onSubmit(resetPassword.form.fields),
              )}>
              <label className="k-form-field reset-password-form-field">
                <span>Username</span>
                <RasaInput.RasaInput placeholder="Your Account Email"
                  validation={RasaInput.validateEmail(resetPassword.form.fields.username || '')}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    updateField({name: 'username', value: e.target.value})}
                  value={resetPassword.form.fields.username} />
              </label>
              {firstLogin &&
              <label className="k-form-field reset-password-form-field">
                <span>'Temporary Password'</span>
                <RasaInput.RasaInput placeholder="Temporary Password"
                  validation={RasaInput.validatePresent(resetPassword.form.fields.confirmation_code || '')}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    updateField({name: 'confirmation_code', value: e.target.value})}
                  value={resetPassword.form.fields.confirmation_code} />
              </label>
              }
              <label className="k-form-field reset-password-form-field">
                <span>New Password</span>
                <RasaInput.RasaInput type="password" placeholder="Your New Password"
                  validation={RasaInput.validatePassword(resetPassword.form.fields.new_password || '')}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    updateField({name: 'new_password', value: e.target.value})}
                  value={resetPassword.form.fields.new_password} />
              </label>
              <label className="k-form-field reset-password-form-field">
                <span>Confirm Password</span>
                <RasaInput.RasaInput type="password" placeholder="Confirm Your New Password"
                  validation={RasaInput.validateConfirm(resetPassword.form.fields.new_password,
                    resetPassword.form.fields.confirm_password)}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    updateField({name: 'confirm_password', value: e.target.value})}
                  value={resetPassword.form.fields.confirm_password} />
              </label>
              <div className="reset-password-form-submit">
              {resetPassword.view.isValidating ?
                <Loading size={Loading.Sizes.SMALL} /> :
                <Button
                  primary={true}
                  type="submit"
                  disabled={resetPassword.form.fields.username === '' ||
                    resetPassword.form.fields.confirmation_code === '' ||
                    RasaInput.validatePassword(resetPassword.form.fields.new_password).invalid ||
                    RasaInput.validateConfirm(resetPassword.form.fields.new_password,
                      resetPassword.form.fields.confirm_password).invalid
                  }>
                  Reset Password
                </Button>
              }
              </div>
            </Form>
          </Col>
        </Row>
      </div>
    </Container>
  </div>

export const ResetPasswordPage = connect(
  ({resetPassword}: Types.WrappedState) => ({
    firstLogin: false,
    resetPassword,
  }),
  {
    onSubmit: Actions.FormActions[RasaForm.SAVE],
    updateField: (field: {}) => Actions.FormActions[RasaForm.UPDATE]({...field, urlParam: false}),
  },
)(ResetPasswordPageConnect)

export const FirstLoginPage = connect(
  ({resetPassword}: Types.WrappedState) => ({
    firstLogin: true,
    resetPassword,
  }),
  {
    onSubmit: Actions.FormActions[RasaForm.SAVE],
    updateField: Actions.FormActions[RasaForm.UPDATE],
  },
)(ResetPasswordPageConnect)



// WEBPACK FOOTER //
// ./src/pages/reset-password/component.tsx